<template>
    <div class="main">
        <!-- Edit account details -->
        <div class="manageAccount__container mx-auto py-16">
            <div class="text-center w-2/5 md:w-1/4 mx-auto">
                <img class="mx-auto" src="@/assets/images/pages/account/manage-account/id-card-icon.svg">
            </div>
            <h2 class="text-center p-3 m-0" v-text="$t('MANAGE_ACCOUNT_UPDATE')"></h2>
            <edit-account-details-form></edit-account-details-form>
        </div>

        <div class="divider--container background--paper clear--sm">
            <div class="divider-white--top"></div>
            <div class="divider-white--bottom"></div>
        </div>

        <!--Edit card details-->
        <div class="manageAccount__container mx-auto py-16 text-center" id="billingAddressForm">
            <h2 v-text="$t('MANAGE_ACCOUNT_CARD_DETAILS')"></h2>
            <div v-if="!showCardForm">
                <p class="mt-4" v-text="$t('MANAGE_ACCOUNT_CARD_NUMBER')"></p>
                <p>---- ---- ---- {{ cardEnding }}</p>
                <div class="w-full mt-4">
                    <button class="btn btn--primary" @click="showCardForm = true"
                        v-text="$t('MANAGE_ACCOUNT_CHANGE_CARD')">
                    </button>
                </div>
            </div>

            <edit-card-details-form-new
                class="mt-4"
                v-if="showCardForm"
                :isUpdate="true"
                @closed="showCardForm = false">
            </edit-card-details-form-new>
        </div>

        <div class="divider--container background--paper clear--sm">
            <div class="divider-white--top"></div>
            <div class="divider-white--bottom"></div>
        </div>
        <!-- Billing details -->
        <div class="bg-white px-8 py-16" id="manageBllingContainer">
            <div class="container accountDeliveryAddresses__container mx-auto text-center">
                <h2 class="pb-4" v-text="$t('MANAGE_ACCOUNT_YOUR_BILLING_ADDRESS')"></h2>
                <manage-billing-address></manage-billing-address>

                <router-link class="link" :to="{name:'account.delivery-addresses'}">
                   {{ $t('MANAGE_ACCOUNT_MANAGE_DELIVERY') }}
                </router-link>
            </div>
        </div>

        <coupon-history :style="{ margin: '40px auto', }" :showExpired="true"/>

        <div class="background--paper divider--container">
            <div class="divider-white--top"></div>
            <div class="manageAccount__container mx-auto text-center py-16">
                <h2 v-text="$t('MANAGE_ACCOUNT_PAYMENT_HISTORY')"></h2>
                <orders-list></orders-list>
                <div class="divider-white--bottom"></div>
            </div>
        </div>

        <div class="bg-white">
            <div class="manageAccount__container mx-auto py-8">
                <div class="w-1/2 mx-auto text-center">
                    <p v-html="$t('MANAGE_ACCOUNT_TO_CANCEL')"></p>
                    <email-us></email-us>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import EditCardDetailsFormNew from '@/components/forms/account/EditCardDetailsFormNew';
import EditAccountDetailsForm from '@/components/forms/account/EditAccountDetailsForm';
import OrdersList from '@/components/partials/account/manage-account/OrdersList';
import ManageBillingAddress from '@/components/partials/account/my-delivery-addresses/ManageBillingAddress';
import emailUs from '@/components/structure/navigation/navigation/EmailUs';
import CouponHistory from '@/components/partials/account/coupon-history/CouponHistory.vue';

export default {
    name: 'ManageAccount',
    data() {
        return {
            showCardForm: false,
        };
    },
    mounted() {
        this.$store.dispatch('address/fetchAllAddresses');

        if (this.expandFormName) {
            this.showCardForm = true;
            this.$scrollTo(`#${this.expandFormName}`);
            this.expandFormName = null;
        }
    },
    computed: {
        cardEnding() {
            return this.$store.getters['payment/getCardEnding'];
        },
        expandFormName: {
            get() {
                return this.$store.getters['account/getExpandFormName'];
            },
            set(value) {
                this.$store.commit('account/updateExpandFormName', value);
            },
        },
    },
    components: {
        EditAccountDetailsForm,
        EditCardDetailsFormNew,
        ManageBillingAddress,
        OrdersList,
        CouponHistory,
        emailUs,
    },
};
</script>
